export default __webpack_public_path__ + "static/media/cm.c5fdb172.svg";